import React, { useState } from 'react';
import './Login.css';

const LOGO = 'https://fotileams.com/fotile-logo-red.png';

export default function Login({ onLogin }) {
  const [employeeId, setEmployeeId] = useState('');
  const [password, setPassword]     = useState('');
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState('');

  const handleLogin = async () => {
    if (!employeeId || !password) {
      setError('Please enter your Employee ID and password');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await fetch('https://fotileams.com/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ employee_id: employeeId, password })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Login failed');
        return;
      }
      localStorage.setItem('token', data.token);
      localStorage.setItem('employee', JSON.stringify(data.employee));
      onLogin(data.employee);
    } catch (err) {
      setError('Cannot connect to server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo">
          <img src={LOGO} alt="Fotile" className="login-logo-img" />
          <div className="login-brand">Fotile AMS</div>
          <div className="login-sub">Employee Attendance Portal</div>
        </div>

        {error && <div className="login-error">{error}</div>}

        <div className="login-form">
          <div className="login-group">
            <label className="login-label">Employee ID</label>
            <input
              className="login-input"
              type="text"
              placeholder="e.g. EMP-001"
              value={employeeId}
              onChange={e => setEmployeeId(e.target.value.toUpperCase())}
              onKeyDown={e => e.key === 'Enter' && handleLogin()}
            />
          </div>
          <div className="login-group">
            <label className="login-label">Password</label>
            <input
              className="login-input"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleLogin()}
            />
          </div>
          <button
            className={`login-btn ${loading ? 'loading' : ''}`}
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </div>

        <div className="login-footer">
          Forgot your password? Contact HR
        </div>
      </div>
    </div>
  );
}